import React from "react";
import { Modal, Form, Input } from "antd";
import { submitFormData } from "../../../HOCs";
import { saveSearch } from "../../../routes/Search/search.ducks";
import { ControlType, NotificationFrequency } from "../../../models";
import { requiredField } from "../../../models/formValidator";
import NotificationSelector from "../../SavedSearchPage/ListSavedSearch/ListSavedSearchWeb/SavedSearchItem/NotificationSelector";

import styles from "./saveSearchForm.scss";
import ReactGA from "react-ga4";
import useHrPageName from "../../../utils/useHrPageName";

const charLimit = 80;

const defaultSettings = {
  form: {
    name: {
      label: "Naziv",
      field: "name",
      rules: [
        requiredField(null, "Unesite naziv pretrage"),
        {
          max: charLimit,
          message: "Naslov pretrage ne može biti duži od 80 znakova."
        }
      ]
    },
    notification: {
      field: "notifyFrequency"
    },
    submitButton: {
      text: "SPREMI"
    }
  },
  modal: {
    title: "Spremi pretragu",
    okText: "Spremi",
    cancelText: "Odustani"
  }
};

// eslint-disable-next-line max-lines-per-function
function SaveSearchForm({
  visible,
  form,
  settings,
  onSubmit,
  onCreate,
  onCancel,
  category,
  tags,
  categoryName
}) {
  const hrPageName = useHrPageName(category);

  const handleCancel = () => {
    if (!category) {
      ReactGA.event({
        category: "Spremanje pretrage",
        action: "Click",
        label: `Odustajanje od snimanja pretrage - Sve kategorije`
      });
    } else {
      ReactGA.event({
        category: "Spremanje pretrage",
        action: "Click",
        label: `Odustajanje od snimanja pretrage - ${hrPageName}`
      });
    }
    form.resetFields();
    onCancel();
  };

  const handleCreate = () => {
    if (!category) {
      ReactGA.event({
        category: "Spremanje pretrage",
        action: "Click",
        label: `Snimanje pretrage - Sve kategorije`
      });
    } else {
      ReactGA.event({
        category: "Spremanje pretrage",
        action: "Click",
        label: `Snimanje pretrage - ${hrPageName}`
      });
    }

    form.validateFields(async (err: any, values: any) => {
      if (err) {
        return;
      }

      await onCreate(values, onSubmit);

      form.resetFields();
    });
  };

  // Get selected category and tags
  const handleInitialValue = () => {
    let initialValue = [];
    let totalCharLength = 0;

    // Get category and push as first element
    let selectedCategory = hrPageName; // sometimes prop selectedCategory is not defined, for ex. when we search in serach bar, and then select category
    if (selectedCategory) {
      initialValue.push(selectedCategory)
      totalCharLength += (selectedCategory.length + 2); // +2 for comma and space
    };

    // Get tags
    if (tags && tags.length > 0) {
      // Check if there is a city tag
      const hasCityIdValue = tags.some(tag => tag.field === "includeCityIds");

      const filteredTags = hasCityIdValue
        ? tags.filter(tag => tag.type !== ControlType.inputLocation || tag.field === "includeCityIds")   // only return location tag if city is selected
        : tags;

      filteredTags.forEach((tag) => {
        // Ensure adding the tag won't exceed the character limit
        if (totalCharLength + (tag.name.length + 2) <= charLimit) {
          initialValue.push(tag.name);
          totalCharLength += (tag.name.length + 2); // +2 for comma and space
        }
      });

     
    }
    // Ensure only 4 tags are returned
    return initialValue.slice(0, 4).join(', ');
  };


  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      onOk={handleCreate}
      okText={settings.modal.okText}
      cancelText={settings.modal.cancelText}
      className={styles.modal}
    >
      <div className={styles.title}>{settings.modal.title}</div>
      <p className={styles.description}>{"Obavijesti šaljemo na e-mail samo ako se pojave novi oglasi koji odgovaraju vašoj pretrazi. U svakom se trenutku možete odjaviti."}</p>
      <Form layout="vertical" className={styles.form}>
        <span className="control-title required">
          {settings.form.name.label}
        </span>
        {/* <HrCategoryName category={category}/> */}
        <Form.Item>
          {form.getFieldDecorator(settings.form.name.field, {
            rules: settings.form.name.rules,
            initialValue: handleInitialValue()
          })(
            <Input
              className={styles.saveName}
              placeholder={"Naziv pretrage"}
            />
          )}
        </Form.Item>
        <Form.Item>
          {form.getFieldDecorator(settings.form.notification.field, {
            initialValue: NotificationFrequency[0].value
          })(
            <NotificationSelector
              radioContainerClassName={styles.radioContainer}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
}

SaveSearchForm.defaultProps = {
  settings: defaultSettings,
  visible: false
};

export default submitFormData(Form.create()(SaveSearchForm), saveSearch);



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SaveSearchForm/index.tsx